import apis from '../../../api/index'
import Vue from 'vue'
const queryAllDepartment = (keyWord) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_DEPARTMENT,
      params: {
        keyword: keyWord
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询顶级部门
const queryTopDepartment = () => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_TOP_DEPARTMENT
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询子部门
const queryChildDepartment = (parentId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_CHILD_DEPARTMENT,
      params: {
        parentId
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
const FormDepartmentSelectConfig = {
  // 类型
  componentType: 'FORM_DEPARTMENT_SELECT',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-org',
    text: '部门选择',
    optionTitle: true,
    description: '用于选择组织中的部门，最多选择50个'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormDepartmentSelect',
      edit: 'FormDepartmentSelect',
      read: 'FormDepartmentSelect'
    },
    chooseType: 'SINGLE',
    multicolor: true,
    chooseOptions: [],
    label: '部门选择',
    placeholder: '请选择部门',
    inTable: true,
    customDefaultKey: 'departmentDefaultValue',
    // 查询平铺部门
    queryAllDepartment: queryAllDepartment,
    // 查询顶级部门
    queryTopDepartment: queryTopDepartment,
    // 查询子部门
    queryChildDepartment: queryChildDepartment,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcConvertDefaultValue: (config) => {
        if (config.defaultValue === 'SpecifyTheDept') {
          return config.departmentDefaultValue
        } else if (config.defaultValue === 'Now') {
          const dept = Vue.prototype.$store.state.tenantModule.department
          console.log(Vue.prototype.$store.state)
          return dept ? [{
            id: dept.id,
            leafNodeFlag: dept.leafNodeFlag || false,
            name: dept.name,
            structureCode: dept.structureCode,
            structureName: dept.structureName
          }] : []
        }
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'CHOOSETYPE',
    'DEPTDEFAULTVALUE',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormDepartmentSelectConfig
